export default function CtaSection() {
  return (
    <section id="cta" className="bg-[#F5F5F0] py-28 md:py-36">
      <div className="max-w-[1360px] mx-auto px-8 md:px-16">
        <div className="relative bg-[#0A0A0A] rounded-3xl overflow-hidden px-8 md:px-20 py-20 md:py-28 text-center">
          {/* Background accent */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[#38C6F5]/8 blur-[100px] pointer-events-none"></div>

          {/* Background image overlay */}
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://public.readdy.ai/ai/img_res/c89045e3f8bb81e8e8e05a3263ee0407.jpg"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="relative z-10 max-w-[720px] mx-auto">
            <span className="text-[#38C6F5] text-xs uppercase tracking-[3px] mb-6 block">
              Ready to Transform?
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extralight text-white leading-tight mb-6">
              Transform your operations into a{' '}
              <span className="font-semibold">revenue engine.</span>
            </h2>
            <p className="text-[#A0A0A0] text-lg leading-relaxed mb-12 max-w-[540px] mx-auto">
              More booked jobs. More qualified clients. More predictable revenue. All powered by systems that run in the background while your team focuses on execution.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:hello@alphaopsai.com"
                className="bg-[#38C6F5] text-black text-sm font-semibold px-10 py-4 rounded-full hover:bg-white transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                Schedule Your Consultation
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="tel:+18005550199"
                className="border border-white/20 text-white text-sm px-10 py-4 rounded-full hover:border-white/50 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-phone-line"></i>
                Call Us Now
              </a>
            </div>

            {/* Trust signals */}
            <div className="mt-16 pt-10 border-t border-white/10 flex flex-col sm:flex-row items-center justify-center gap-8">
              {[
                { icon: 'ri-shield-check-line', label: 'No long-term contracts' },
                { icon: 'ri-settings-3-line', label: 'Custom-built for your business' },
                { icon: 'ri-customer-service-2-line', label: 'Dedicated implementation support' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2 text-[#707070] text-sm">
                  <div className="w-5 h-5 flex items-center justify-center text-[#38C6F5]">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
